// Handle mega-menu for full size navigation
document.addEventListener("DOMContentLoaded", () => {
    "use strict";

    // Cache static elements
    const mainEl = document.querySelector("main");
    const headerEl = document.querySelector("header");
    const bodyEl = document.body;

    const navContainer = headerEl?.querySelector(".nav-container");
    const breadcrumbContainer = mainEl?.querySelector(".breadcrumb-container");
    const environmentEl = headerEl?.querySelector(".environment");
    const alertsContainer = headerEl?.querySelector("#alerts-container");
    const mainNavContents = document.getElementById("main-nav-contents");

    // Check if body shouldn't have top margin
    const isSpecialPage = ["homepage", "standardpagesubsite", "subsitehomepage"].some(cls =>
        bodyEl.classList.contains(cls)
    );

    let activeFetchController = null;

    function setWindowTop() {
        if (mainEl) mainEl.style.marginTop = "0";
        if (navContainer) navContainer.classList.remove("fixed");
        if (breadcrumbContainer) {
            breadcrumbContainer.style.position = "relative";
            breadcrumbContainer.style.marginTop = "";
        }
    }

    function setWindowScroll() {
        if (navContainer) navContainer.classList.add("fixed");
        if (breadcrumbContainer) breadcrumbContainer.style.position = "fixed";

        let margin = navContainer?.offsetHeight || 0;

        if (environmentEl && (environmentEl.offsetWidth > 0 || environmentEl.offsetHeight > 0)) {
            margin -= environmentEl.offsetHeight;
        }

        if (!isSpecialPage && mainEl) {
            mainEl.style.marginTop = `${margin}px`;
        }

        if (alertsContainer && breadcrumbContainer && (alertsContainer.offsetWidth > 0 || alertsContainer.offsetHeight > 0)) {
            breadcrumbContainer.style.marginTop = `-${alertsContainer.offsetHeight}px`;
        }
    }

    // Optimize scroll event with requestAnimationFrame
    let scrollAnimationFrame;
    window.addEventListener("scroll", () => {
        if (scrollAnimationFrame) {
            cancelAnimationFrame(scrollAnimationFrame);
        }

        scrollAnimationFrame = requestAnimationFrame(() => {
            const hasVisibleNav = mainNavContents && (mainNavContents.offsetWidth > 0 || mainNavContents.offsetHeight > 0);
            const hasOpenMegamenu = mainNavContents?.querySelector(".megamenu.show");

            if (hasVisibleNav && !hasOpenMegamenu) {
                if (window.scrollY > 0) {
                    setWindowScroll();
                } else {
                    setWindowTop();
                }
            } else {
                setWindowTop();
            }
        });
    });

    /**
     * Helper to chunk an array into a specified number of parts (round-robin)
     */
    function chunkArray(arr, numParts) {
        const result = Array.from({ length: numParts }, () => []);
        arr.forEach((item, index) => {
            result[index % numParts].push(item);
        });
        return result;
    }

    /**
     * Generate HTML for mega-menu links safely using DOM elements or templates
     */
    function buildMegaMenuItemContent(items, isSimple) {
        const itemSet = chunkArray(items, isSimple ? items.length : 3);

        const columnsHtml = itemSet.map(itemArr => {
            if (!itemArr || !itemArr.length) return "";

            const linksHtml = itemArr.map(item => {
                const expandedClass = item.expanded ? ' class="expanded"' : "";
                let itemContent = `<a href="${encodeURI(item.url)}"${expandedClass}>${escapeHTML(item.name)}</a>`;

                if (item.children?.length) {
                    const childLinks = item.children.map(child => {
                        const childExpanded = child.expanded ? ' class="expanded"' : "";
                        return `<a href="${encodeURI(child.url)}"${childExpanded}>${escapeHTML(child.name)}</a>`;
                    }).join("");

                    itemContent += isSimple ? `<div class="sub">${childLinks}</div>` : childLinks;
                }

                return `<div class="mm-links">${itemContent}</div>`;
            }).join("");

            const colClass = isSimple ? "" : ' class="col-4"';
            return `<div${colClass}>${linksHtml}</div>`;
        }).join("");

        return isSimple
            ? `<div>${columnsHtml}</div>`
            : `<div class="row mm-items">${columnsHtml}</div>`;
    }

    function buildMegaMenuImageContent(imagePage) {
        if (!imagePage) return "";
        const bgImage = `${encodeURI(imagePage.imageUrl)}`;

        return `
            <a class="mmimg" href="${encodeURI(imagePage.url)}">
                <span class="mmimg-img" style="background-image:url('${bgImage}')"></span>
                <span class="mmimg-content">
                    <span class="mmimg-title">${escapeHTML(imagePage.title)}</span>
                    <span class="mmimg-description">${escapeHTML(imagePage.description)}</span>
                </span>
            </a>
        `;
    }

    function escapeHTML(str) {
        if (!str) return "";
        return String(str)
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&#039;");
    }

    function updateNavActiveStates() {
        if (!mainNavContents) return;
        const navLinks = mainNavContents.querySelectorAll(".nav-link");
        const expandedItem = Array.from(navLinks).find(link => !link.classList.contains("collapsed"));

        navLinks.forEach(link => {
            link.classList.remove("inactive");
            if (expandedItem && link !== expandedItem) {
                link.classList.add("inactive");
            }
        });
    }

    function clearMegaMenuContent() {
        mainNavContents?.querySelectorAll(".megamenu").forEach(m => m.innerHTML = "");
    }

    function createMegaMenuSkeleton(imageContent, isSimple) {
        if (isSimple) {
            return `<div class="items-container"></div>`;
        }

        return `
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="mmcontainer">
                            <div class="row">
                                <div class="col-3">${imageContent}</div>
                                <div class="col-9 mm-itemscontainer">
                                    <button type="button" class="mm-close">
                                        <img src="/img/mm-close.svg" alt="close Menu" width="28" height="28"/>
                                    </button>
                                    <div class="items-container"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        `;
    }

    // Event Delegation on mainNavContents for Bootstrap Collapse events
    if (mainNavContents) {
        mainNavContents.addEventListener("shown.bs.collapse", updateNavActiveStates);
        mainNavContents.addEventListener("hidden.bs.collapse", updateNavActiveStates);

        mainNavContents.addEventListener("show.bs.collapse", async (e) => {
            if (!e.target.classList.contains("nav-items-container")) return;

            window.scrollTo(0, 0);
            setWindowTop();
            clearMegaMenuContent();

            // Cancel existing fetch request if fast toggling happens
            if (activeFetchController) {
                activeFetchController.abort();
            }
            activeFetchController = new AbortController();

            const content = e.target;
            const navItem = content.closest(".nav-item");

            // Safely parse JSON dataset properties
            const parseDatasetJSON = (value) => {
                try { return value ? JSON.parse(value) : null; }
                catch { return null; }
            };

            const topImagePage = parseDatasetJSON(content.dataset.tip);
            const bottomImagePage = parseDatasetJSON(content.dataset.bip);
            const isSimple = content.dataset.style === "simple";

            const imageContent = buildMegaMenuImageContent(topImagePage) + buildMegaMenuImageContent(bottomImagePage);
            const innerStructure = createMegaMenuSkeleton(imageContent, isSimple);

            const { pageid: id, selected: currentPageId } = content.dataset;
            content.innerHTML = `<div style="height:1000px"></div>`;

            try {
                const response = await fetch(`/api/mainnav/menuitems/?id=${id}&currentPageId=${currentPageId}`, {
                    method: "POST",
                    signal: activeFetchController.signal
                });

                if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

                const jsonData = await response.json();

                let itemContent = "";
                if (jsonData?.items?.length) {
                    itemContent = buildMegaMenuItemContent(jsonData.items, isSimple);
                }

                content.innerHTML = innerStructure;
                const itemsContainer = content.querySelector(".items-container");
                if (itemsContainer) {
                    itemsContainer.innerHTML = itemContent;
                }

                // Collapse other siblings
                if (navItem?.parentNode) {
                    Array.from(navItem.parentNode.children).forEach(sibling => {
                        if (sibling !== navItem) {
                            const cnt = sibling.querySelector(".nav-items-container");
                            if (cnt?.classList.contains("show")) {
                                const siblingNavLink = cnt.closest(".nav-item")?.querySelector(".nav-link");
                                siblingNavLink?.click();
                            }
                        }
                    });
                }

                // Attach close button click handler
                const closeBtn = content.querySelector(".mm-close");
                closeBtn?.addEventListener("click", () => {
                    const parentNavLink = closeBtn.closest(".nav-item")?.querySelector(".nav-link");
                    parentNavLink?.click();
                });

            } catch (error) {
                if (error.name !== "AbortError") {
                    console.error("Error fetching navigation data:", error);
                }
            }
        });
    }
});